import Vue from "vue";

Vue.prototype.$availablematerialprod = [
  "matprod0",
  "matprod1",
  "matprod2",
  "matprod3",
  // "matprod4",
  "matprod5",
  "matprod6",
  "matprod7",
  "matprod8",
  "matprod9",
  "matprod10"
];
